export class MapAssetWithIcon {
  alias: string;
  description: string;
  uuid: string;
  icon: string;
  status: string;
  representationId: string;

  constructor(alias: string, description: string, uuid: string, icon: string, status: string, representationId: string) {
    this.alias = alias;
    this.description = description;
    this.uuid = uuid;
    this.icon = icon;
    this.status = status;
    this.representationId = representationId;
  }

  public getIdentifier() {
    const idWithStatus: string = `${this.representationId}-${this.status}`;
    return `${this.status ? idWithStatus : this.representationId}`;
  }


}
